import { BindingEngine, computedFrom, observable } from "aurelia-binding";
import { autoinject } from "aurelia-dependency-injection";
import { useView } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { CustomerSubscriptionModel, SubscriptionProductCodes } from "../../../../../../../../models/customers/customer-subscription.models";
import { DataGridColumn, DataType, ItemSource, QueryFilter, SourceType } from "../../../../../../../../models/queries/queries.models";
import { CustomGridPageBase } from "../../../../../../common/custom-grid-page.base";
import { MobileHelper } from "../../../../../../../../helpers/mobile-helper";
import KeyDownEvent = JQuery.KeyDownEvent;
import * as moment from "moment";
import { SubscriptionHelper } from "../../../../helpers/subscription-helper";

@autoinject
@useView('views/pages/modules/my-subscription/tabs/information-services/tabs/vessel-changes/vessel-changes.html')
export class VesselChanges extends CustomGridPageBase {

    private _subscriptionProductCode: string;
    public canAddVessel: boolean;
    public appliedFilter: string;
    public itemSource: ItemSource = null;
    public customerSubscription: CustomerSubscriptionModel;

    @observable()
    filter: string;

    public customerId: number;
    public isRightShipUser: boolean;

    @computedFrom('customerId')
    get currentCustomerId() {
        if(this.customerId) {
            this.itemSource = this.getItemSource();
        }
        return this.customerId;
    }

    //Get subscription end date
    @computedFrom("customerSubscription")
    get subscriptionEndDate() {
        if(this.customerSubscription?.doesNotExpire) {
            return "Does not expire";
        }
        else if(this.customerSubscription?.subscriptionEndDate) {
            return moment(this.customerSubscription.subscriptionEndDate).format('DD MMM YYYY');
        }
        else {
            return "N/A";
        }
    }
    
    constructor(i18N: I18N, bindingEngine: BindingEngine, private subscriptionHelper: SubscriptionHelper) {
        super(i18N, 'Vessels', bindingEngine);
    }

    activate(model: {customerId: number, subscription: CustomerSubscriptionModel, isRightShipUser: boolean, subscriptionProductCode: string}) {
        //this.getMySubscription();
        this.customerId = model.customerId;
        this.customerSubscription = model.subscription;
        this.isRightShipUser = model.isRightShipUser;
        this._subscriptionProductCode = model.subscriptionProductCode;
    }

    attached() {
        // this.customerSubscriptionService.getMySubscription(SubscriptionProductCodes.informationServices).then(response => {
        //     this.customerSubscription = response.customerSubscription;
        //     this.itemSource = this.getItemSource();
        // })
    }

    filterKeyDown($event) {
        const e: KeyDownEvent = $event.detail;

        if (e.key == "Enter") {
            this.appliedFilter = this.filter;
        }
    }

    upgradeSubscription() {
        const productCode = this._subscriptionProductCode == SubscriptionProductCodes.pscRiskIqInApp
            ? SubscriptionProductCodes.pscRiskIq
            : null;
        const url: string = this.subscriptionHelper.getUpgradeSubscriptionUrl(productCode);
        window.open(url, "_blank");
    }

    getItemSource() {
        this.columns = this.getColumns();
        const initialFilters = [];
        initialFilters.push(QueryFilter.getQuery("customerId", this.customerId, "eq", DataType.Number, true));
        const sourceUrl = this.isRightShipUser ? `/odata/CustomerVesselChanges?customerId=${this.customerId}&productCode=${this._subscriptionProductCode}` : `/odata/CustomerVesselChanges?productCode=${this._subscriptionProductCode}`;
        return {
            sourceType: SourceType.ODataUrl,
            source: sourceUrl,
            columns: this.columns,
            initialSorting: this.initialSorting,
            initialFilters: initialFilters
        };
    }

    getColumns(): DataGridColumn[] {
        return [
            {
                dataType: DataType.CustomTemplate,
                value: '<div class="row">' +

                    //From vessel
                    '<div class="column">' +
                    '<span>${item.fromName}</span>' +
                    '<span if.bind="item.fromInternationalMaritimeOrganizationNumber">IMO ${item.fromInternationalMaritimeOrganizationNumber}</span>' +
                    '<span if.bind="item.fromVehicleIdentificationNumber">VIN ${item.fromVehicleIdentificationNumber}</span>' +
                    '<span if.bind="item.fromEuropeanNumberOfIdentification">ENI ${item.fromEuropeanNumberOfIdentification}</span>' +
                    '</div>' +

                    '<div>' +
                    '<comp-icon class="icon-arrow" icon="arrow-right">' +
                    '</div>' +

                    //To vessel
                    '<div class="column">' +
                    '<a class="link" href="/vessel/${item.toVesselId}">${item.toName}</a>' +
                    '<span if.bind="item.toInternationalMaritimeOrganizationNumber">IMO ${item.toInternationalMaritimeOrganizationNumber}</span>' +
                    '<span if.bind="item.toVehicleIdentificationNumber">VIN ${item.toVehicleIdentificationNumber}</span>' +
                    '<span if.bind="item.toEuropeanNumberOfIdentification">ENI ${item.toEuropeanNumberOfIdentification}</span>' +
                    '</div>' +
                    '</div>',
                name: "fromName",
                title: MobileHelper.isMobileDevice() && window.innerWidth < 1024 ? "" : "Vessel change",
                instancePerRow: true,
                sortOrder: 2,
                columnOrder: -1,
                isHidden: false,
                isSortable: true,
                parameter: {
                    item: null
                }
            },
            {
                columnOrder: 3,
                sortOrder: 3,
                dataType: DataType.CustomTemplate,
                value: '<span>${item.updatedBy}</span>',
                name: 'updatedBy',
                title: 'Updated by',
                instancePerRow: true,
                isHidden: false,
                isSortable: true,
                parameter: {
                    item: null
                }
            },
            {
                columnOrder: 4,
                sortOrder: 4,
                dataType: DataType.Date,
                name: 'changeDate',
                title: 'Change date',
                isSortable: true,
                valueConverter: (date: Date | string) => date
                    ? moment(date).format('DD MMM YYYY HH:mm')
                    : ''
            }
        ];
    }
}